import { Dispatch, FC, SetStateAction } from "react";

import Button from "../../BaseComponents/Button";
import Modal from "../../BaseComponents/Modal";
import { Col, Row } from "../../BaseComponents/Flex";

interface IntegratorPassModalProps {
  title?: string;
  message?: string;
  acceptButtonText?: string;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  rejectButtonText?: string;
}

const IntegratorPassModal: FC<IntegratorPassModalProps> = ({
  title,
  message,
  acceptButtonText,
  setIsOpen,
}) => {
  const onAcceptClick = async () => {};

  return (
    <Modal
      info={message}
      maxWidth={450}
      setIsOpen={setIsOpen}
      title={title}
      isClosable={false}
    >
      <Row justifyContent='center' isResponsive noMargin>
        <Col size={0.3}>
          <Button onClick={onAcceptClick} text={acceptButtonText} />
        </Col>
      </Row>
    </Modal>
  );
};

export default IntegratorPassModal;
